import Axios from "axios";

const IDENTITY_ME_URL = "https://api.rajchandra.me/identity/auth/me";
const IDENTITY_REFRESH_URL = "https://api.rajchandra.me/identity/auth/refresh";

const fetchMe = () => Axios.get(IDENTITY_ME_URL, { withCredentials: true });

// Returns one of:
//   { status: "ok", user }            - valid session, possibly after a refresh
//   { status: "unauthenticated" }     - confirmed logged out (no valid refresh token either)
//   { status: "error" }               - transient failure (network/CORS/5xx) - not proof of logout
export const getIdentityUser = async () => {
    try {
        const response = await fetchMe();
        return { status: "ok", user: response.data?.data?.user || null };
    } catch (e) {
        if (e.response?.status !== 401) {
            return { status: "error" };
        }

        try {
            await Axios.post(IDENTITY_REFRESH_URL, null, {
                withCredentials: true,
            });
        } catch (refreshError) {
            return { status: "unauthenticated" };
        }

        try {
            const retryResponse = await fetchMe();
            return {
                status: "ok",
                user: retryResponse.data?.data?.user || null,
            };
        } catch (retryError) {
            return retryError.response?.status === 401
                ? { status: "unauthenticated" }
                : { status: "error" };
        }
    }
};
